import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  assetsDir: string;
  isStaticExport: boolean;
  auth: {
    method: 'jwt';
    skip: boolean;
    redirectPath: string;
  };
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'Nexmail',
  appVersion: packageJson.version,
  // Consolidated backend HTTP API endpoint (see docs/frontend-migration.md)
  serverUrl: import.meta.env.VITE_API_URL ?? '',
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? '',
  isStaticExport: import.meta.env.VITE_STATIC_EXPORT === 'true',
  /**
   * Auth
   * @method jwt
   */
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: paths.dashboard.root,
  },
};
